module.exports = __webpack_public_path__ + "img/profile.33ffe4fb.svg";